/**
 * Shape `/health` for the Overview. It lives in its own module so the spread
 * order is testable without pulling in the fetch client (which needs a DOM).
 *
 * #910 review: `...data` spreads FIRST. It used to spread last, which worked
 * only because the agent happens to name the key `segments` — if `/health` ever
 * returned `segment_scores`, the raw array would overwrite the mapped one and
 * silently drop the population field. The derived keys must win.
 */
export function selectHealth(data) {
  return {
    ...data,
    overall_score: data?.overall_score ?? data?.network_score ?? null,
    // #908: the score's population rides along so the gauge can show what a
    // score averages over. A 0 across one device and a 0 across four hundred
    // are different claims and looked identical on the Overview.
    //
    // #910 review: `scored_devices`, not `device_count` — the agent now reports
    // the devices that actually produced a score, which is the population the
    // mean is over. The segment's total device count is a different number, and
    // reporting it here read as "all of them are dead".
    segment_scores: (data?.segment_scores ?? data?.segments ?? []).map((s) => ({
      ...s,
      scored_devices: s?.scored_devices ?? null,
    })),
    collectors: data?.collectors ?? [],
  };
}
